import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  Autocomplete,
  Backdrop,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Drawer,
  FormControlLabel,
  MenuItem,
  Popover,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { Base64 } from "js-base64";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import useReducer from "../../library/hooks/useReducer";
import Booking from "../components/bhSKhoe/Booking";
import DetailDialog from "../components/bhSKhoe/DetailDialog";
import ErrReports from "../components/bhSKhoe/ErrReports";
import InfoDialog from "../components/bhSKhoe/InfoDialog";
import OTPVerify from "../components/bhSKhoe/OTPVerify";
import OrderDialog from "../components/bhSKhoe/OrderDialog";
import ReferalInfo from "../components/bhSKhoe/ReferalInfo";
import SuccessDialog from "../components/bhSKhoe/SuccessDialog";
import Loc from "./../assets/icons/loc.svg";

import {
  BpCheckedIcon,
  BpIcon,
  genders,
  hospitalGuaranteeName,
  initialState,
  orderByArr,
  searchFees,
} from "../extra/hard-data";
import {
  createEventGtag,
  formatDiscountCurrency,
  formatMoney,
  getParamUrl,
  resolveIdentifier,
} from "../extra/utils";
import bhSKhoeReducer from "../reducers/bhSKhoeReducer";
import { useStyles } from "../styles/bhskStyles";

import cart from "../assets/icons/cart.svg";
import empty from "../assets/icons/empty.svg";
import infoIcon from "../assets/icons/info-icon.svg";
import logoDefault from "../assets/icons/logo_default.svg";
import share from "../assets/icons/share.svg";
import showMenu from "../assets/icons/show-menu.svg";
import booking from "../assets/images/booking.png";
import reportErr from "../assets/icons/report-err.svg";
import { getShareContent } from "../../controller/bhskApi";
import InforCompany from "../components/bhSKhoe/inforCompany";

function BHSucKhoe({ isMobile, productSelected }) {
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();
  const { package_ } = useParams();
  const productTag = package_ ? (package_.includes(".") ? package_.split(".")[0] : package_) : "";
  console.log("productTag:", productTag);

  const inputProviderRef = useRef(null);
  const inputAgeRef = useRef(null);

  const [state, dispatch] = useReducer({
    reducer: bhSKhoeReducer,
    name: "bhSKhoeReducer",
    initialState,
    navigate,
    location,
    productSelected,
    package_,
  });

  useEffect(() => {
    dispatch("initial");
  }, []);

  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);

  const {
    providers,
    ageArr,
    dataSearch,
    data,
    dataBooking,
    dataInfo,
    dataReferal,
    dataErrReport,
    openDetail,
    openOrder,
    openOTPVerify,
    openSuccess,
    loading,
    expanding,
    page,
    errors,
    openMDInfoCompany
  } = state;

  const [appliedFilterCount, setAppliedFilterCount] = useState(0);

  const calcBadgeCount = (searchObj = dataSearch) => {
    return (
      (searchObj?.provider ? 1 : 0) +
      (searchObj?.fees ? 1 : 0) +
      (searchObj?.age ? 1 : 0) +
      (searchObj?.gender && searchObj?.gender !== 3 ? 1 : 0) +
      (searchObj?.orderBy ? 1 : 0) +
      (searchObj?.discount ? 1 : 0) +
      ((searchObj?.category || []).length > 0 ? (searchObj?.category || []).length : 0)
    );
  };

  useEffect(() => {
    if (dataSearch?.age || dataSearch?.provider) {
      setAppliedFilterCount(calcBadgeCount(dataSearch));
    }
  }, [state?.providers?.length]);

  const getShareContex = async () => {
    const slug = package_.split(".")[0];
    const id = package_.split(".")[1];
    dispatch("onLoading");
    const getShareContexApi = await getShareContent(slug, id);
    dispatch("offLoading");
    if (getShareContexApi?.statusCode !== 200) {
      toast.error("Lấy dữ liệu thất bại");
    }
    const dataResult = getShareContexApi?.result || {};
    const dataStep1 = dataResult?.referralCode
      ? { ...state.dataStep1, referralCode: dataResult.referralCode }
      : { ...state.dataStep1 };
    dispatch({ type: "setState_", payload: { shareContext: dataResult, dataStep1 } });
  };

  useEffect(() => {
    const dataResult = state.shareContext;
    if (dataResult.benefitsDetailUidList) {
      dispatch({
        type: "getDetail",
        benefitsDetailUidList: dataResult?.benefitsDetailUidList,
        infoFilter: dataResult?.infoFilter,
        gender: dataResult?.gender,
        referalCode: dataResult?.referralCode || "",
      });
      dispatch("openDetailDialog");
    }
  }, [state.shareContext]);

  useEffect(() => {
    if (
      package_ &&
      package_.includes(".") &&
      resolveIdentifier(package_.split(".")[1])?.type === "flakeId"
    ) {
      getShareContex();
    } else {
      const benefitsDetailUidList = getParamUrl("benefitsDetailUidList");
      const infoFilter = getParamUrl("infoFilter");
      const gender = getParamUrl("gender");
      const handleDetail = async () => {
        await dispatch({
          type: "getDetail",
          benefitsDetailUidList,
          infoFilter,
          gender,
        });
        dispatch("openDetailDialog");
      };
      if (benefitsDetailUidList) {
        handleDetail();
      }
    }
  }, [location?.search]);

  // const systemLocale = "vi";

  return (
    <>
      <div className={classes.search}>
        <div className="searchBox">
          {/* {!isMobile ? (
            <div id="benefit" style={{ display: "flex" }}>
              <div className="label">Quyền lợi BH:</div>
              <FormGroup row key={_.uniqueId()}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes("noi_tru")}
                      name="noi_tru"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Nội trú"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "ngoai_tru"
                      )}
                      name="ngoai_tru"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Ngoại trú"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes("rang")}
                      name="rang"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Răng"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "thai_san"
                      )}
                      name="thai_san"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Thai sản"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "tu_vong_thuong_tat_tai_nan"
                      )}
                      name="tu_vong_thuong_tat_tai_nan"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Tử vong, thương tật vĩnh viễn do tai nạn"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "tu_vong_thuong_tat_benh_tat_thai_san"
                      )}
                      name="tu_vong_thuong_tat_benh_tat_thai_san"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Tử vong, thương tật vĩnh viễn do bệnh tật, thai sản"
                />
              </FormGroup>
            </div>
          ) : (
            <Grid id="benefit" container>
              <Grid xs={12} sm={12} md={2}>
                <div className="label">Quyền lợi BH:</div>
              </Grid>
              <Grid xs={6} sm={6} md={1.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes("noi_tru")}
                      name="noi_tru"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Nội trú"
                />
              </Grid>
              <Grid xs={6} sm={6} md={1.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "ngoai_tru"
                      )}
                      name="ngoai_tru"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Ngoại trú"
                />
              </Grid>
              <Grid xs={6} sm={6} md={1.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes("rang")}
                      name="rang"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Răng"
                />
              </Grid>
              <Grid xs={6} sm={6} md={1.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "thai_san"
                      )}
                      name="thai_san"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Thai sản"
                />
              </Grid>
              <Grid xs={12} sm={12} md={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "tu_vong_thuong_tat_tai_nan"
                      )}
                      name="tu_vong_thuong_tat_tai_nan"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Tử vong, thương tật vĩnh viễn do tai nạn"
                />
              </Grid>
              <Grid xs={12} sm={12} md={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(dataSearch?.category || []).includes(
                        "tu_vong_thuong_tat_benh_tat_thai_san"
                      )}
                      name="tu_vong_thuong_tat_benh_tat_thai_san"
                      onChange={(e) => dispatch({ type: "handleCheck", e })}
                      icon={<BpIcon />}
                      checkedIcon={<BpCheckedIcon />}
                    />
                  }
                  label="Tử vong, thương tật vĩnh viễn do bệnh tật, thai sản"
                />
              </Grid>
            </Grid>
          )} */}

          <Grid container spacing={2} className="mt-10">
            {(!isMobile || getParamUrl("platform") !== "app") && (
              <Grid xs={getParamUrl("platform") !== "app" ? 5 : 12} sm={12} md={3}>
                <Autocomplete
                  options={providers}
                  getOptionLabel={(option) => option?.title || ""}
                  size="small"
                  value={dataSearch?.provider || null}
                  inputValue={dataSearch?.inputValueProvider || ""}
                  onInputChange={(e, newValue, reason) => {
                    if (reason === "input" || reason === "clear") {
                      dispatch({
                        type: "onChangeSearch",
                        name: "inputValueProvider",
                        value: newValue,
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputRef={inputProviderRef}
                      placeholder="Nhà bảo hiểm"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          const matchingOption = providers.find((option) =>
                            option.title
                              .toLowerCase()
                              .includes(
                                dataSearch?.inputValueProvider.toLowerCase(),
                              ),
                          );

                          if (matchingOption) {
                            dispatch({
                              type: "onChangeSearch",
                              name: "provider",
                              value: matchingOption,
                            });
                            inputProviderRef.current?.blur();
                            if (isMobile) {
                              dispatch("getList");
                            }
                          }
                        }
                      }}
                    />
                  )}
                  onChange={(e, newValue) => {
                    dispatch({
                      type: "onChangeSearch",
                      name: "provider",
                      value: newValue,
                    });
                    dispatch({
                      type: "onChangeSearch",
                      name: "inputValueProvider",
                      value: newValue?.title || "",
                    });
                    if (isMobile) {
                      dispatch("getList");
                    }
                  }}
                  className={!dataSearch?.provider ? "age" : ""}
                  classes={{ option: classes.option }}
                  // slotProps={{
                  //   popper: {
                  //     style: { width: "fit-content", minWidth: "22vw", textAlign: 'right' },
                  //   },
                  // }}
                  openOnFocus
                  clearOnEscape
                />
              </Grid>
            )}
            {
              (getParamUrl("platform") === "app" || !isMobile) &&
              <Grid xs={5} sm={12} md={3}>
                <TextField
                  select
                  label="Phí bảo hiểm"
                  value={dataSearch?.fees || ""}
                  size="small"
                  fullWidth
                  onChange={(e) => {
                    dispatch({
                      type: "onChangeSearch",
                      name: "fees",
                      value: e.target.value,
                    });
                    if (isMobile) {
                      dispatch("getList");
                    }
                  }}
                >
                  {searchFees.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item.id}
                      className={classes.option}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            }
            <Grid xs={5} sm={12} md={3}>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disableFuture
                  format="DD/MM/YYYY"
                  className="dob-search"
                  value={dataSearch?.dob || null}
                  onChange={(newValue) =>
                    dispatch({
                      type: "onChangeSearch",
                      name: "dob",
                      value: newValue,
                    })
                  }
                />
              </LocalizationProvider>
              {errors.includes("dobInvalid") && (
                <div className="err">Độ tuổi không hợp lệ</div>
              )}
              {errors.includes("dobFilter") && (
                <div className="err">Vui lòng chọn ngày sinh</div>
              )} */}

              <Autocomplete
                options={ageArr}
                getOptionLabel={(option) => option?.title || ""}
                size="small"
                value={dataSearch?.age || null}
                inputValue={dataSearch?.inputValueAge || ""}
                onInputChange={(e, newValue, reason) => {
                  if (reason === "input" || reason === "clear") {
                    dispatch({
                      type: "onChangeSearch",
                      name: "inputValueAge",
                      value: newValue,
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputRef={inputAgeRef}
                    placeholder="Chọn độ tuổi"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const matchingOption = ageArr.find((option) =>
                          option.title
                            .toLowerCase()
                            .includes(
                              (dataSearch?.inputValueAge || "").toLowerCase(),
                            ),
                        );
                        if (matchingOption) {
                          dispatch({
                            type: "onChangeSearch",
                            name: "age",
                            value: matchingOption,
                          });
                          dispatch({
                            type: "onChangeSearch",
                            name: "inputValueAge",
                            value: matchingOption?.title || "",
                          });
                          inputAgeRef.current?.blur();
                          if (isMobile) {
                            dispatch("getList");
                          }
                        }
                      }
                    }}
                  />
                )}
                onChange={(e, newValue) => {
                  dispatch({
                    type: "onChangeSearch",
                    name: "age",
                    value: newValue,
                  });
                  dispatch({
                    type: "onChangeSearch",
                    name: "inputValueAge",
                    value: newValue?.title || "",
                  });
                  if (isMobile) {
                    dispatch("getList");
                  }
                }}
                className={
                  !dataSearch?.age
                    ? `age ${errors.includes("ageFilter") ? "age-err" : ""}`
                    : ""
                }
                classes={{ option: classes.option }}
                openOnFocus
                clearOnEscape
              />
              {errors.includes("ageFilter") && (
                <div className="err">Vui lòng chọn độ tuổi</div>
              )}
            </Grid>
            {
              isMobile &&
              <Grid xs={2}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                  onClick={() => setOpenFilterDrawer(true)}
                >
                  <div style={{ position: "relative", display: "inline-flex" }}>
                    <img src={Loc} alt="filter" width={24} height={24} />
                    {appliedFilterCount > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: 2,
                          right: -4,
                          backgroundColor: "#E16B2F",
                          color: "#fff",
                          borderRadius: "50%",
                          width: 16,
                          height: 16,
                          fontSize: 11,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {appliedFilterCount}
                      </span>
                    )}
                  </div>
                  <span
                    style={{
                      color: "#1A427D",
                      fontSize: 14,
                      fontWeight: 500,
                      marginTop: 2,
                    }}
                  >
                    Lọc
                  </span>
                </div>
              </Grid>
            }
            {!isMobile && (
              <>
                <Grid xs={6} sm={6} md={1.5}>
                  <Button
                    variant="contained"
                    className="btn-search"
                    onClick={() => {
                      dispatch("getList");
                      createEventGtag("health_home_search_btn");
                    }}
                  >
                    Tìm kiếm
                  </Button>
                </Grid>
                <Grid xs={6} sm={6} md={1.5}>
                  <Button
                    className="btn-outline"
                    onClick={() => {
                      dispatch("resetFilter");
                      dispatch("getList");
                    }}
                  >
                    Xoá bộ lọc
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </div>

        {!isMobile ? (
          <div className="filter-data">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className="nowrap">Sắp xếp theo:</div>
              <TextField
                select
                value={dataSearch?.orderBy || 2}
                size="small"
                fullWidth
                onChange={(e) => {
                  dispatch({
                    type: "onChangeSearch",
                    name: "orderBy",
                    value: e.target.value,
                  });
                  dispatch("getList");
                  createEventGtag("health_home_filter_sort_list");
                }}
                style={{ minWidth: 180 }}
              >
                {orderByArr.map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.option}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <div className="line"></div>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => {
                      dispatch({
                        type: "onChangeSearch",
                        name: "discount",
                        value: e.target.checked,
                      });
                      dispatch("getList");
                      createEventGtag("health_home_filter_discount");
                    }}
                    icon={<BpIcon />}
                    checkedIcon={<BpCheckedIcon />}
                  />
                }
                label="Giảm giá"
                className="nowrap"
              />
              <div className="line"></div>
              <div className="nowrap">Giới tính:</div>
              <TextField
                select
                value={dataSearch?.gender || 3}
                size="small"
                fullWidth
                onChange={(e) => {
                  dispatch({
                    type: "onChangeSearch",
                    name: "gender",
                    value: e.target.value,
                  });
                  dispatch("getList");
                  createEventGtag("health_home_filter_gender");
                }}
              >
                <MenuItem value={3} className={classes.option}>
                  Tất cả
                </MenuItem>
                {genders.map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.option}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div style={{ textAlign: isMobile ? "start" : "end" }}>
              Có <b style={{ color: "#1A427D" }}>{page?.total}</b> sản phẩm được
              tìm thấy
            </div>
          </div>
        ) : (
          <div className="my-15">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <div style={{ textAlign: "end" }}>
                Có <b style={{ color: "#1A427D" }}>{page?.total}</b> sản phẩm được tìm thấy
              </div>
            </div>

            <Drawer
              anchor="bottom"
              open={openFilterDrawer}
              onClose={() => setOpenFilterDrawer(false)}
              PaperProps={{
                style: {
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                  padding: 20,
                  maxHeight: "85vh",
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <div style={{ fontWeight: 700, color: "#003478", fontSize: 18, textAlign: 'center', width: '100%' }}>
                  Bộ lọc tìm kiếm
                </div>
              </div>

              <Grid container spacing={2}>
                {
                  (!productTag) &&
                  <Grid xs={12}>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '150px', fontSize: 14, color: '#343A40' }}>Nhà bảo hiểm</div>
                      <Autocomplete
                        style={{ width: '100%' }}
                        options={providers}
                        getOptionLabel={(option) => option?.title || ""}
                        size="small"
                        value={dataSearch?.provider || null}
                        inputValue={dataSearch?.inputValueProvider || ""}
                        onInputChange={(e, newValue, reason) => {
                          if (reason === "input" || reason === "clear") {
                            dispatch({
                              type: "onChangeSearch",
                              name: "inputValueProvider",
                              value: newValue,
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{ width: '100%' }}
                            {...params}
                            inputRef={inputProviderRef}
                            placeholder="Chọn nhà bảo hiểm"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const matchingOption = providers.find((option) =>
                                  option.title
                                    .toLowerCase()
                                    .includes(
                                      dataSearch?.inputValueProvider.toLowerCase(),
                                    ),
                                );

                                if (matchingOption) {
                                  dispatch({
                                    type: "onChangeSearch",
                                    name: "provider",
                                    value: matchingOption,
                                  });
                                  dispatch({
                                    type: "onChangeSearch",
                                    name: "inputValueProvider",
                                    value: matchingOption?.title || "",
                                  });
                                  inputProviderRef.current?.blur();
                                }
                              }
                            }}
                          />
                        )}
                        onChange={(e, newValue) => {
                          dispatch({
                            type: "onChangeSearch",
                            name: "provider",
                            value: newValue,
                          });
                          dispatch({
                            type: "onChangeSearch",
                            name: "inputValueProvider",
                            value: newValue?.title || "",
                          });
                        }}
                        className={!dataSearch?.provider ? "age" : ""}
                        classes={{ option: classes.option }}
                        // slotProps={{
                        //   popper: {
                        //     style: { width: "fit-content", minWidth: "100%" },
                        //   },
                        // }}
                        openOnFocus
                        clearOnEscape
                      />
                    </div>
                  </Grid>
                }
                <Grid xs={12}>
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '150px', fontSize: 14, color: '#343A40' }}>Phí bảo hiểm</div>
                    <TextField
                      select
                      label=""
                      value={dataSearch?.fees || "1"}
                      size="small"
                      fullWidth
                      placeholder="Chọn phí bảo hiểm"
                      onChange={(e) => {
                        dispatch({
                          type: "onChangeSearch",
                          name: "fees",
                          value: e.target.value,
                        });
                      }}
                    >
                      {searchFees.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.id}
                          className={classes.option}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Grid>

                <Grid xs={12}>
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '150px', fontSize: 14, color: '#343A40' }}>Độ tuổi</div>
                    <div style={{ width: '100%' }}>
                      <Autocomplete
                        style={{ width: '100%' }}
                        options={ageArr}
                        getOptionLabel={(option) => option?.title || ""}
                        size="small"
                        value={dataSearch?.age || null}
                        inputValue={dataSearch?.inputValueAge || ""}
                        onInputChange={(e, newValue, reason) => {
                          if (reason === "input" || reason === "clear") {
                            dispatch({
                              type: "onChangeSearch",
                              name: "inputValueAge",
                              value: newValue,
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{ width: '100%' }}
                            {...params}
                            inputRef={inputAgeRef}
                            placeholder="Chọn độ tuổi"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const matchingOption = ageArr.find((option) =>
                                  option.title
                                    .toLowerCase()
                                    .includes(
                                      (dataSearch?.inputValueAge || "").toLowerCase(),
                                    ),
                                );
                                if (matchingOption) {
                                  dispatch({
                                    type: "onChangeSearch",
                                    name: "age",
                                    value: matchingOption,
                                  });
                                  dispatch({
                                    type: "onChangeSearch",
                                    name: "inputValueAge",
                                    value: matchingOption?.title || "",
                                  });
                                  inputAgeRef.current?.blur();
                                }
                              }
                            }}
                          />
                        )}
                        onChange={(e, newValue) => {
                          dispatch({
                            type: "onChangeSearch",
                            name: "age",
                            value: newValue,
                          });
                          dispatch({
                            type: "onChangeSearch",
                            name: "inputValueAge",
                            value: newValue?.title || "",
                          });
                        }}
                        className={
                          !dataSearch?.age
                            ? `age ${errors.includes("ageFilter") ? "age-err" : ""}`
                            : ""
                        }
                        classes={{ option: classes.option }}
                        openOnFocus
                        clearOnEscape
                      />
                      {errors.includes("ageFilter") && (
                        <div className="err" style={{ fontSize: 14, color: 'red' }}><i>Vui lòng chọn độ tuổi</i></div>
                      )}
                    </div>
                  </div>
                </Grid>

                <Grid xs={12}>
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '150px', fontSize: 14, color: '#343A40' }}>Giới tính</div>
                    <TextField
                      select
                      label=""
                      value={dataSearch?.gender || 3}
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        dispatch({
                          type: "onChangeSearch",
                          name: "gender",
                          value: e.target.value,
                        });
                        createEventGtag("health_home_filter_gender");
                      }}
                    >
                      <MenuItem value={3} className={classes.option}>
                        Tất cả
                      </MenuItem>
                      {genders.map((option) => (
                        <MenuItem
                          key={option.id}
                          value={option.id}
                          className={classes.option}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Grid>

                <Grid xs={12}>
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '150px', fontSize: 14, color: '#343A40' }}>Sắp xếp</div>
                    <TextField
                      select
                      label=""
                      value={dataSearch?.orderBy || 2}
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        dispatch({
                          type: "onChangeSearch",
                          name: "orderBy",
                          value: e.target.value,
                        });
                        createEventGtag("health_home_filter_sort_list");
                      }}
                    >
                      {orderByArr.map((option) => (
                        <MenuItem
                          key={option.id}
                          value={option.id}
                          className={classes.option}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '150px', fontSize: 14, color: '#343A40' }}>Giảm giá</div>
                    <FormControlLabel
                      style={{ width: '100%' }}
                      control={
                        <Checkbox
                          checked={Boolean(dataSearch?.discount)}
                          onChange={(e) => {
                            dispatch({
                              type: "onChangeSearch",
                              name: "discount",
                              value: e.target.checked,
                            });
                            createEventGtag("health_home_filter_discount");
                          }}
                          icon={<BpIcon />}
                          checkedIcon={<BpCheckedIcon />}
                        />
                      }
                      label=""
                    />
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div style={{ width: '100%', border: '0.5px solid #D6DEEB', margin: '0px auto', marginBottom: 7 }}></div>
                </Grid>
                <Grid xs={6} style={{ marginBottom: 14 }}>
                  <Button
                    style={{ width: '100%', background: '#fff', borderRadius: 8, border: '1px solid #003478', color: '#003478', textTransform: 'none' }}
                    onClick={() => {
                      dispatch("resetFilter");
                      dispatch("getList");
                      setAppliedFilterCount(calcBadgeCount({
                        category: [],
                        provider: getParamUrl("provider_id") ? (providers || []).find((i) => i.id == getParamUrl("provider_id")) || null : null,
                        fees: "",
                        age: (ageArr || []).find((i) => i.value === 25) || null,
                        gender: 3,
                        orderBy: 2,
                        discount: 0,
                      }));
                      setOpenFilterDrawer(false);
                    }}
                  >
                    Xoá bộ lọc
                  </Button>
                </Grid>

                <Grid xs={6}>
                  <Button
                    style={{ width: '100%', background: '#003478', borderRadius: 8, textTransform: 'none' }}
                    variant="contained"
                    onClick={() => {
                      dispatch("getList");
                      createEventGtag("health_home_search_btn");
                      setAppliedFilterCount(calcBadgeCount(dataSearch));
                      setOpenFilterDrawer(false);
                    }}
                  >
                    Tìm kiếm
                  </Button>
                </Grid>
              </Grid>
            </Drawer>
          </div>
        )}

        {loading && (
          <div className="loading">
            <CircularProgress size={25} style={{ color: "#1A427D" }} />
            <div className="loading-text">Đang tải BH...</div>
          </div>
        )}

        {!dataSearch?.hasAge && !loading && (
          <div className="empty-filter">
            Vui lòng chọn độ tuổi để tìm kiếm sản phẩm
          </div>
        )}

        {_.isEmpty(data) && dataSearch?.hasAge ? (
          <div className="empty">
            <img src={empty} alt="empty" style={{ margin: '0px auto' }} />
          </div>
        ) : (
          <>
            <Grid container style={{ margin: "20px 0 20px" }} columnSpacing={isMobile ? 0 : 2} rowSpacing={2}>
              {data.map((i, index) => (
                <ProductItem
                  item={i}
                  index={index}
                  dispatch={dispatch}
                  classes={classes}
                />
              ))}
            </Grid>
            {page.total > data.length && (
              <div>
                {expanding ? (
                  <div className="expanding">
                    <CircularProgress
                      size={16}
                      style={{ color: "#1A427D", marginRight: 8 }}
                    />
                    Đang tải...
                  </div>
                ) : (
                  <div
                    className="expand-more"
                    onClick={() => {
                      dispatch("changePage");
                      createEventGtag("health_home_expand_more_click");
                    }}
                  >
                    Xem thêm <ExpandMoreIcon />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
      {openMDInfoCompany && (
        <InforCompany isMobile={isMobile} state={state} dispatch={dispatch} />
      )}
      {openDetail && (
        <DetailDialog state={state} dispatch={dispatch} isMobile={isMobile} />
      )}
      {openOrder && (
        <OrderDialog state={state} dispatch={dispatch} isMobile={isMobile} package_={package_} />
      )}
      {openOTPVerify && (
        <OTPVerify isMobile={isMobile} state={state} dispatch={dispatch} />
      )}
      {openSuccess && <SuccessDialog state={state} dispatch={dispatch} />}

      {!!dataBooking?.open && <Booking state={state} dispatch={dispatch} />}

      {!!dataInfo?.open && (
        <InfoDialog dataInfo={dataInfo} dispatch={dispatch} />
      )}
      {!!dataReferal?.open && (
        <ReferalInfo dataReferal={dataReferal} dispatch={dispatch} />
      )}

      {!!dataErrReport?.open && (
        <ErrReports dataErrReport={dataErrReport} dispatch={dispatch} />
      )}

      <img
        src={booking}
        alt="booking-img"
        className={classes.bookingImg}
        onClick={() => dispatch("openBooking")}
      />
    </>
  );
}

export default BHSucKhoe;

const ProductItem = ({ item, index, dispatch, classes }) => {
  const divRef = useRef(null);
  const divProminentRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "excluded-region-popover" : undefined;

  const [anchorElProminent, setAnchorElProminent] = useState(null);
  const openProminent = Boolean(anchorElProminent);
  const idProminent = openProminent ? "prominent-popover" : undefined;

  return (
    <Grid xs={12} sm={12} md={4} lg={3} key={index} className={classes.boxItem}>
      <div className="box">
        <div>
          <div className="title-box">
            <div className="logo">
              <img
                src={item?.providerLogo || logoDefault}
                alt="logo"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </div>
            <div className={item?.discount ? "mr-discount" : "mr-10"}>
              <div className="title">{item?.productTitle || ""}</div>
              <div className="gray">{item?.providerTitle || ""}</div>
            </div>
            <div className="share">
              <img
                src={showMenu}
                alt="show-menu"
                style={{ rotate: "90deg" }}
                onClick={() => dispatch({ type: "openShare", index })}
              />
            </div>
            {item?.discount && (
              <div className="discount">
                Giảm{" "}
                {item?.discount > 100
                  ? formatDiscountCurrency(item?.discount)
                  : `${item?.discount}%`}
              </div>
            )}
          </div>
          <div className="line"></div>
          <div className="bg-box">
            <div className="title-1">{item?.packagesTitle || ""}</div>
            <div className="fee">
              {/* fees is fee before discount */}
              {formatMoney(
                item?.feesPayment ? item?.feesPayment : item?.fees,
              ) || 0}{" "}
              VNĐ
            </div>
            {item?.feesPayment && (
              <div className="discount-fee">
                Giá gốc: {formatMoney(item?.fees) || 0}
                {" VNĐ"}
              </div>
            )}
          </div>
          <div className="line"></div>
          <div className="info">
            <div className="row">
              <div>Giới tính:</div>
              <div className="value">
                {genders.find((i) => i.id === item?.gender)?.label || "N/A"}
              </div>
            </div>
            <div className="row">
              <div>Độ tuổi</div>
              <div className="value">
                {item?.age?.type === "day"
                  ? "Dưới 1 tuổi"
                  : `${item?.age?.value || ""} tuổi`}
              </div>
            </div>
            <div className="row">
              <div>Phạm vi bảo hiểm:</div>
              <div className="value">{item?.regions?.name || "N/A"}</div>
            </div>
            <div className="data-row">
              <div style={{ whiteSpace: "nowrap" }}>Khu vực loại trừ:</div>
              <div className="row">
                <div
                  ref={divRef}
                  title={item?.excludedRegion || ""}
                  className="value-2 ellipsis"
                >
                  {item?.excludedRegion || "N/A"}
                </div>
                {divRef?.current?.offsetWidth > 120 && (
                  <>
                    <img
                      src={infoIcon}
                      alt="infoIcon"
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                    />
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={() => setAnchorEl(null)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <div
                        style={{ padding: 10, fontSize: 14, maxWidth: "200px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ fontWeight: 500, color: "#646D69" }}>
                            Khu vực loại trừ
                          </div>
                          <CloseIcon
                            style={{ width: 18, color: "#646D69" }}
                            onClick={() => setAnchorEl(null)}
                          />
                        </div>
                        <Divider style={{ margin: "4px 0 8px" }} />
                        <div> {item?.excludedRegion || "N/A"}</div>
                      </div>
                    </Popover>
                  </>
                )}
              </div>
            </div>

            <div className="line"></div>

            {_.isArray(item?.prominentBenefits) ? (
              <>
                {(item?.prominentBenefits || []).map((benefit, index) => (
                  <div key={index} className="data-row">
                    <div>{benefit?.label}</div>
                    {index === 6 ? (
                      <div className="row">
                        <div
                          ref={divProminentRef}
                          title={benefit?.value || ""}
                          className="value-3"
                          dangerouslySetInnerHTML={{
                            __html: benefit?.value || "N/A",
                          }}
                        />

                        {divProminentRef?.current?.offsetWidth > 130 && (
                          <>
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              onClick={(e) =>
                                setAnchorElProminent(e.currentTarget)
                              }
                            />
                            <Popover
                              id={idProminent}
                              open={openProminent}
                              anchorEl={anchorElProminent}
                              onClose={() => setAnchorElProminent(null)}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                            >
                              <div
                                style={{
                                  padding: 10,
                                  fontSize: 14,
                                  maxWidth: "200px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 500,
                                      color: "#646D69",
                                    }}
                                  >
                                    Khác
                                  </div>
                                  <CloseIcon
                                    style={{ width: 18, color: "#646D69" }}
                                    onClick={() => setAnchorElProminent(null)}
                                  />
                                </div>
                                <Divider style={{ margin: "4px 0 8px" }} />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: benefit?.value || "",
                                  }}
                                />
                              </div>
                            </Popover>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="value-1">
                        {formatMoney(benefit?.value) || 0} VNĐ
                      </div>
                    )}
                  </div>
                ))}
                <div className="data-row">
                  <div style={{ whiteSpace: "nowrap" }}>Bảo lãnh viện phí</div>
                  <div className="value-2">
                    {(item?.hospitalGuarantee || [])
                      .map((key) => hospitalGuaranteeName(key))
                      .join(", ") || "N/A"}
                  </div>
                </div>
              </>
            ) : (
              // old prominentBenefits is object
              <>
                <div className="data-row">
                  <div>Tử vong, thương tật vĩnh viễn do tai nạn:</div>
                  <div className="value-1">
                    {formatMoney(
                      item?.prominentBenefits?.tu_vong_thuong_tat_tai_nan,
                    ) || 0}{" "}
                    VNĐ
                  </div>
                </div>
                <div className="data-row">
                  <div>Tử vong, thương tật vĩnh viễn do bệnh tật:</div>
                  <div className="value-1">
                    {formatMoney(
                      item?.prominentBenefits?.tu_vong_thuong_tat_benh_thai_san,
                    ) || 0}{" "}
                    VNĐ
                  </div>
                </div>
                <div className="data-row">
                  <div>Nội trú/ năm:</div>
                  <div className="value-1">
                    {formatMoney(item?.prominentBenefits?.noi_tru_tren_nam) ||
                      0}{" "}
                    VNĐ
                  </div>
                </div>
                <div className="data-row">
                  <div>• Viện phí/ ngày</div>
                  <div className="value-1">
                    {formatMoney(item?.prominentBenefits?.vien_phi_tren_ngay) ||
                      0}{" "}
                    VNĐ
                  </div>
                </div>
                <div className="data-row">
                  <div>Ngoại trú/ năm:</div>
                  <div className="value-1">
                    {formatMoney(item?.prominentBenefits?.ngoai_tru_tren_nam) ||
                      0}{" "}
                    VNĐ
                  </div>
                </div>
                <div className="data-row">
                  <div>• Giới hạn/ lần khám</div>
                  <div className="value-1">
                    {formatMoney(
                      item?.prominentBenefits?.gioi_han_tren_lan_kham,
                    ) || 0}{" "}
                    VNĐ
                  </div>
                </div>
                <div className="data-row">
                  <div style={{ whiteSpace: "nowrap" }}>Bảo lãnh viện phí</div>
                  <div className="value-2">
                    {(item?.hospitalGuarantee || [])
                      .map((key) => hospitalGuaranteeName(key))
                      .join(", ") || "N/A"}
                  </div>
                </div>
                <div className="data-row">
                  <div>Khác</div>
                  <div className="row">
                    <div
                      ref={divProminentRef}
                      title={item?.prominentBenefits?.khac || ""}
                      className="value-3"
                    >
                      {item?.prominentBenefits?.khac || "N/A"}
                    </div>
                    {divProminentRef?.current?.offsetWidth > 130 && (
                      <>
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          onClick={(e) => setAnchorElProminent(e.currentTarget)}
                        />
                        <Popover
                          id={idProminent}
                          open={openProminent}
                          anchorEl={anchorElProminent}
                          onClose={() => setAnchorElProminent(null)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                        >
                          <div
                            style={{
                              padding: 10,
                              fontSize: 14,
                              maxWidth: "200px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{ fontWeight: 500, color: "#646D69" }}
                              >
                                Khác
                              </div>
                              <CloseIcon
                                style={{ width: 18, color: "#646D69" }}
                                onClick={() => setAnchorElProminent(null)}
                              />
                            </div>
                            <Divider style={{ margin: "4px 0 8px" }} />
                            <div>{item?.prominentBenefits?.khac || "N/A"}</div>
                          </div>
                        </Popover>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div>
          <div className="line"></div>
          <div className="center">
            <Button
              variant="contained"
              className="btn"
              onClick={() => {
                dispatch({ type: "setSelectItem", item });
                dispatch({
                  type: "getDetail",
                  benefitsDetailUidList: item?.benefitsDetailUidList,
                  infoFilter: item?.infoFilter,
                  gender: Base64.encode(item?.gender || ""),
                  openOrder: true,
                });
                // dispatch("openOrderDialog");
                dispatch({ type: "addCustomerViews", item });
                createEventGtag("health_home_buy_now_btn");
              }}
            >
              <img src={cart} alt="cart" className="btn-icon" />
              Mua ngay
            </Button>
            <div
              className="underline"
              onClick={() => {
                dispatch({ type: "checkInfoToViewDetail", item });
                dispatch({ type: "addCustomerViews", item });
                createEventGtag("health_home_view_detail_btn");
              }}
            >
              Xem chi tiết
            </div>
          </div>
        </div>
      </div>
      {item?.openShare && (
        <div style={{ position: "relative" }}>
          <div className="menu-share">
            <MenuItem
              onClick={() => dispatch({ type: "openReferalInfo", item })}
            >
              <img src={share} alt="share" className="share-icon" />
              Chia sẻ
            </MenuItem>
            {/* <MenuItem onClick={() => dispatch({ type: "openErrReport", item })}>
              <img src={reportErr} alt="report" className="share-icon" />
              Báo lỗi
            </MenuItem> */}
          </div>
        </div>
      )}
      <Backdrop
        style={{
          zIndex: 9,
          color: "#fff",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        open={item?.openShare}
        onClick={() => dispatch("closeShare")}
      />
    </Grid>
  );
};
